import { db } from './config';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';

export const deleteUserGoals = async (userId) => {
  const goalsRef = collection(db, 'goals');
  const q = query(goalsRef, where('userId', '==', userId));
  const querySnapshot = await getDocs(q);
  
  const deletions = querySnapshot.docs.map(doc => deleteDoc(doc.ref));
  await Promise.all(deletions);
};

export const deleteUserReflections = async (userId) => {
  const reflectionsRef = collection(db, 'reflections');
  const q = query(reflectionsRef, where('userId', '==', userId));
  const querySnapshot = await getDocs(q);
  
  const deletions = querySnapshot.docs.map(doc => deleteDoc(doc.ref));
  await Promise.all(deletions);
};

export const deleteUserDoc = async (userId) => {
  const userRef = doc(db, 'users', userId);
  await deleteDoc(userRef);
}; 